import { FIREBASE_TOKEN } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type FirebaseTokenResponse = {
    token?: string;
    message?: string;
};
export default async function fetchFirebaseToken(): Promise<FirebaseTokenResponse> {
    return fetchWithRefresh(FIREBASE_TOKEN, {
        mode: 'cors',
        credentials: 'include',
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('fetchFirebaseToken failed');
        }
    });
}
